import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPage";
import ReaderPage from "@/pages/ReaderPage";
import PlayerPage from "@/pages/PlayerPage";
import StorePage from "@/pages/StorePage";
import PurchaseSuccessPage from "@/pages/PurchaseSuccessPage";
import PurchaseCancelPage from "@/pages/PurchaseCancelPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
          <Route path="/purchase/cancel" element={<PurchaseCancelPage />} />
          
          {/* App pages */}
          <Route path="/app" element={<HomePage />} />
          <Route path="/reader/:bookNumber" element={<ReaderPage />} />
          <Route path="/player/:bookNumber" element={<PlayerPage />} />
          
          {/* Legacy routes */}
          <Route path="/player" element={<PlayerPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
